import { SearchTerm } from "./SearchTerm";

const CommonZoneSearch: SearchTerm[] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'czName',
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    }
];

export default CommonZoneSearch;
